import type { Environment } from '../app/common/interfaces/utilities/environment';

export const environment: Environment = {
  type: 'stage',
  publicApiNamespace: 'auth',
  apiUrl: 'https://api.stage.onyxalfa.com/api/v1',
  mercureUrl: 'https://api.stage.onyxalfa.com/.well-known/mercure',
  frontendUrl: 'https://app.stage.onyxalfa.com',
  hereMapsApiKey: '-8GDzbLolb5XS6g2COpmBmXiliSvSrBoZHEfPLvuGV0',
} as const;
